module.exports = __webpack_public_path__ + "static/media/prime-logo.ddc11aec.svg";